export default {
  methods: {
    convertDate(stringDate) {
      const [datePart] = stringDate.split('T');

      const [year, month, day] = datePart.split('-');

      const formatedDate = `${day}/${month}/${year}`;

      return formatedDate;
    },
  },
};
